*,
*:before,
*:after {
    box-sizing: border-box;
}

es-table-detail {
    display: block;
    --grid-columns: repeat(2, 1fr);
}

dl {
    display: grid;
    grid-template-columns: var(--grid-columns);
    grid-gap: 20px;
    gap: 20px;
    padding: 20px 0;
}

.cell {
    display: flex;
    flex-direction: row;
    line-height: 1.5;
}

.cell.full_width {
        grid-column: 1 / -1;
    }

dt {
    font-weight: bold;
    text-align: left;
    flex: 0 0 150px;
    margin: 0;
    margin-right: 20px;
}

dt::after {
        content: ':';
    }

dd {
    flex: 1 1 100%;
    margin: 0;
}
